// ============================================================================
// SPANISH TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// Tesoros espirituales extraídos de la Palabra

export const bibleTreasures = [
  {
    type: "perle_sagesse",
    content: "La sabiduría divina no es teoría abstracta, sino vida concreta que se manifiesta en nuestras elecciones diarias",
    reference: "Proverbios 3:13-18",
    category: "sabiduría",
    strongNumbers: {
      "sabiduría": "H2451", // חָכְמָה (chokmah) = sabiduría práctica
      "entendimiento": "H8394" // תְּבוּנָה (tebunah) = discernimiento
    },
    reflection: "¿Cómo puedo aplicar la sabiduría divina en mis decisiones hoy?"
  },
  {
    type: "tresor_divine",
    content: "El amor de Dios no es condicional a nuestros méritos, sino un regalo eterno que fluye de Su naturaleza misma",
    reference: "Romanos 8:38-39",
    category: "amor",
    strongNumbers: {
      "amor": "G26", // ἀγάπη (agape) = amor incondicional
      "separar": "G5563" // χωρίζω (chorizo) = separar
    },
    reflection: "Nada puede separarnos del amor de Dios revelado en Cristo"
  },
  {
    type: "lumiere_vie",
    content: "Jesús es la luz que ilumina no solo nuestro camino, sino también nuestro ser interior",
    reference: "Juan 8:12",
    category: "identidad",
    strongNumbers: {
      "luz": "G5457", // φῶς (phos) = luz
      "vida": "G2222" // ζωή (zoe) = vida abundante
    },
    reflection: "¿Cómo dejo que la luz de Cristo ilumine mis áreas de oscuridad?"
  },
  {
    type: "force_divine",
    content: "Nuestra fuerza no proviene de nosotros mismos, sino de Aquel que habita en nosotros",
    reference: "Efesios 3:16-17",
    category: "poder",
    strongNumbers: {
      "fortalecidos": "G2901", // κραταιόω (krataioo) = fortalecer
      "poder": "G1411" // δύναμις (dynamis) = poder divino
    },
    reflection: "En mis momentos de debilidad, ¿confío en la fuerza de Dios?"
  },
  {
    type: "paix_profonde",
    content: "La paz de Dios no depende de las circunstancias externas, sino de Su presencia constante en nuestros corazones",
    reference: "Filipenses 4:6-7",
    category: "serenidad",
    strongNumbers: {
      "paz": "G1515", // εἰρήνη (eirene) = paz completa
      "guardará": "G5432" // φρουρέω (phroureo) = guardar como fortaleza
    },
    reflection: "¿Cómo cultivo la paz de Dios que sobrepasa todo entendimiento?"
  },
  {
    type: "esperance_vivante",
    content: "Nuestra esperanza no es un deseo incierto, sino una ancla sólida fundamentada en las promesas fieles de Dios",
    reference: "Hebreos 6:19",
    category: "esperanza",
    strongNumbers: {
      "esperanza": "G1680", // ἐλπίς (elpis) = esperanza confiada
      "ancla": "G45" // ἄγκυρα (ankyra) = ancla del alma
    },
    reflection: "¿En qué promesas de Dios anclo mi esperanza hoy?"
  },
  {
    type: "transformation",
    content: "La transformación espiritual es un proceso continuo donde nos convertimos cada día más en la imagen de Cristo",
    reference: "2 Corintios 3:18",
    category: "crecimiento",
    strongNumbers: {
      "transformados": "G3339", // μεταμορφόω (metamorphoo) = transformar completamente
      "gloria": "G1391" // δόξα (doxa) = gloria divina
    },
    reflection: "¿Qué áreas de mi vida necesitan transformación hoy?"
  }
];

export default bibleTreasures;
